import { connect } from 'react-redux';

import * as searchActions from '../search/actions';
import SearchComponent from './SearchComponent';

const mapStateToProps = ({ search }) => ({
  query: search.query,
  hasFocus: search.focus,
});

const mapDispatchToProps = dispatch => ({
  onSearchInputChange: e =>
    dispatch(searchActions.onSearchInputChange(e.target.value)),
  onSearchSubmit: e => {
    e.preventDefault();
    dispatch(searchActions.onSearchSubmit(e.target.query.value));
  },
  onFocus: () => dispatch(searchActions.onSearchFocus),
  onBlur: () => dispatch(searchActions.onSearchBlur),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchComponent);



// WEBPACK FOOTER //
// ./src/components/Search.js